import restApi from "@plannel/services/utils/rest-api";

const getAll = params => {
  return restApi.post("/api/production-limit", params);
};

const getAllForCSV = params => {
  return restApi.post("/api/production-limit/csv", params);
};

const upsert = data => {
  return restApi.post("/api/production-limit/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/production-limit/${ids}`);
};

const productionLimitService = {
  getAll,
  getAllForCSV,
  upsert,
  remove
};

export default productionLimitService;